import { ViewChild, Component, Renderer, HostListener } from '@angular/core';
import {
    ViewController,
    NavParams, 
    PopoverCmp,
    PopoverController} from 'ionic-angular';

import { Horse } from '../../model/horse';
import { Account } from '../../model/account';

import { Keyboard } from '@ionic-native/keyboard'

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { AddHorsePage } from '../../pages/horse/add-horse';

@Component({
    selector: 'horse-search',
    templateUrl: 'horse-search.html'
})
export class HorseSearchPopover {
    @ViewChild('horseSearch') horseSearch;

    searchTitle: string = "Horse Search";
    searchChangeObservable;
    selecting: boolean = false;

    eventPublished = false;
    callbackEvent: string = '';
    searchValue: string = '';
    selectedHorse: Horse;
    
    horses: Horse[];
    searchHorses: Horse[];
    accountId: number;

    popoverActive: boolean = false;

    constructor(
                private navParams : NavParams,
                private viewController: ViewController,
                private renderer: Renderer,
                private popoverController: PopoverController,
                private keyboard: Keyboard) {        
    }

    ionViewDidEnter() {
        const element = this.horseSearch._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            this.renderer.invokeElementMethod(element, 'focus', []);
            this.keyboard.show();
        }, 0);

        this.horses = this.navParams.get('horses');
        this.accountId = this.navParams.get("accountId");
        this.searchHorses = this.horses;
    }

    onSearchChange(searchEvent, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(250) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForHorse(searchValue) });
        }

		this.searchChangeObservable.next(searchValue);
    }

    searchForHorse(searchValue : string) {     
        this.searchHorses = this.horses.filter(x => x.name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));

        if (this.searchHorses.length > 0)
            this.selectedHorse = this.searchHorses[0];
	}

    selectItem(horse: Horse) {
        this.viewController.dismiss({ horse: horse })
    }

    getSearchMessage() {
        if (this.searchValue == undefined || this.searchValue.trim().length == 0)
            return "";
        else if (this.searchHorses == undefined || this.searchHorses.length < 1)
            return "There are no horses by that name.";

        return "";
    }

    _bdClick() {
        return this.viewController.dismiss({}, 'backdrop');
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (!this.viewController.isLast())
            return;

        if (ev.keyCode === 27) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        } else if (ev.keyCode === 38 && this.searchHorses.length > 0) {
            if (this.searchHorses[0] !== this.selectedHorse) {
                let index = this.searchHorses.indexOf(this.selectedHorse);

                this.selectedHorse = this.searchHorses[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.searchHorses.length > 0) {
            if (this.searchHorses[this.searchHorses.length - 1] !== this.selectedHorse) {
                let index = this.searchHorses.indexOf(this.selectedHorse);

                this.selectedHorse = this.searchHorses[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedHorse) {
            this.selectItem(this.selectedHorse);
        }
    }

    addNewHorse() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let firstName = '';
        let lastName = '';

        if (this.searchValue.indexOf(' ') > 0) {
            firstName = this.searchValue.split(' ')[0];
            lastName = this.searchValue.split(' ')[1];
        }

        let newHorse = new Horse();
        newHorse.name = this.searchValue;

        let callback = (newHorse) => {
            newHorse = newHorse;
        }

        let entryModal = this.popoverController.create(AddHorsePage, { accountId: this.accountId, horse: newHorse, callback: callback, firstName: firstName, lastName: lastName }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            console.log("newHorse: ", newHorse);

            if (newHorse != null)
                this.viewController.dismiss({ horse: newHorse })
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/search/horse-search.ts